import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.injectTimezoneSubscriptionTags()
  }

  injectTimezoneSubscriptionTags() {
    this.injectHiddenSubscriptionTag(this.timezoneOffsetString);
    this.injectHiddenSubscriptionTag(this.timezoneRegion);
  }

  injectHiddenSubscriptionTag(value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = "tag";
    input.value = value;
    this.element.appendChild(input);
  }

  get timezoneOffsetInMinutes() {
    return new Date().getTimezoneOffset();
  }

  get timezoneOffsetString() {
    const timezoneOffsetInMinutes = this.timezoneOffsetInMinutes
    const offsetHours = parseInt(timezoneOffsetInMinutes / 60);
    const offsetMinutes = Math.abs(timezoneOffsetInMinutes % 60);

    // Create a string representation, adjusting the sign for conventional display
    const sign = timezoneOffsetInMinutes > 0 ? "-" : "+";
    return `UTC: ${sign}${Math.abs(offsetHours).toString().padStart(2, '0')}${offsetMinutes.toString().padStart(2, '0')}`;
  }

  get timezoneRegion() {
    const isDST = this.isDSTNow();
    const utcOffsetHours = -this.timezoneOffsetInMinutes / 60;
    
    // Adjust thresholds based on DST status
    if (isDST) {
      // DST-adjusted thresholds (shifts everything by +1 hour)
      if (utcOffsetHours >= -11 && utcOffsetHours < -3) {
        return 'Americas';
      } else if (utcOffsetHours >= -3 && utcOffsetHours < 6) {
        return 'Europe+Africa';
      } else if (utcOffsetHours >= 6 && utcOffsetHours <= 15) {
        return 'Asia+Pacific';
      }
    } else {
      // Standard time thresholds (original logic)
      if (utcOffsetHours >= -12 && utcOffsetHours < -4) {
        return 'Americas';
      } else if (utcOffsetHours >= -4 && utcOffsetHours < 5) {
        return 'Europe+Africa';
      } else if (utcOffsetHours >= 5 && utcOffsetHours <= 14) {
        return 'Asia+Pacific';
      }
    }
    
    return 'Unknown'; // In case of an unexpected value
  }

  isDSTNow(d = new Date()) {
    const year = d.getFullYear();
    
    // Pick dates ~6 months apart to capture the DST swing (both hemispheres)
    const jan = new Date(Date.UTC(year, 0, 1));
    const jul = new Date(Date.UTC(year, 6, 1));
    
    const janOffset = jan.getTimezoneOffset(); // minutes
    const julOffset = jul.getTimezoneOffset(); // minutes
    
    // If offsets are the same, no DST in this timezone
    if (janOffset === julOffset) {
      return false;
    }
    
    // Standard time has the LARGER (more positive) offset.
    const standardOffset = Math.max(janOffset, julOffset);
    
    // If today's offset is smaller than standard, DST is in effect.
    return d.getTimezoneOffset() < standardOffset;
  }
}